// libraries
import { useWatch, Control } from 'react-hook-form'
import { Typography } from '@mui/material'
import Big from 'big.js'

// utils
import { losslessToFixed } from 'utils/helpers'
import { ROUNDING_PRECISIONS } from 'utils/constants'
import { safeNumber } from 'components/containers/invoice-payments/utils/utils'

interface RemainderCellProps {
  control: Control<any>
  pricePrepend: string
  id: string
  amountDue: number
}

export const RemainderCell: React.FC<RemainderCellProps> = ({ control, pricePrepend, id, amountDue }) => {
  const invoiceFormData = useWatch({
    control,
    name: `invoices.${id}`,
    defaultValue: {},
  })

  const amountPaid = Big(safeNumber(invoiceFormData?.amountPaid))
  const adjustment = Big(safeNumber(invoiceFormData?.adjustment))
  const remainder = Big(safeNumber(amountDue)).sub(amountPaid).sub(adjustment).round(ROUNDING_PRECISIONS.COST)
  return <Typography variant="body2">{`${pricePrepend}${losslessToFixed(remainder.toNumber(), 2)}`}</Typography>
}
